import { Grid, List, ListItem as ListItemMUI } from '@material-ui/core';

import styled from 'styled-components';

import { mediaQueries, getColorHeader, fontFamily } from '../../../../libs';

export const Container = styled.footer`
  display: flex;
  align-items: center;
  flex-direction: column;
  background: #f5f5f5;
  width: 100%;
  bottom: 0;
  padding: 0 0 50px 0;

  * {
    font-family: ${fontFamily};
  }
`;

export const ListStyled = styled(List)`
  padding: 0 !important;
`;

export const ContentContainer = styled.div`
  max-width: ${mediaQueries.default}px !important;
  padding: 12px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;

  @media (max-width: ${mediaQueries.smDefault}px) {
    justify-content: flex-start;
  }
`;

export const ListTitle = styled.p`
  font-weight: bold;
  width: 100%;
  font-size: 15px !important;
  margin: 0;
  padding: 5px;
  height: 40px;

  @media (max-width: ${mediaQueries.smDefault}px) {
    height: 65px;
    justify-content: center;
    padding: 18px 5px;
  }
`;

export const ListItem = styled(ListItemMUI)`
  padding: 5px !important;
  width: fit-content !important;
`;

export const Link = styled.a`
  display: flex;
  align-items: center;
  font-size: 13px;
  min-width: 80%;
  text-transform: capitalize !important;

  &:hover {
    text-decoration: underline;
  }
`;

export const LegalInfo = styled(Grid)`
  font-size: 13px;
  text-align: justify;
  color: #444;
  margin-top: 22px;
`;

export const ContainerCR = styled(Grid)`
  background: ${getColorHeader};
`;

export const ContentCR = styled(Grid)`
  max-width: ${mediaQueries.default}px;
`;
